import { atom } from 'jotai';
import { shouldShowDevTool } from './DevTool';
// Store for logged events (max 200)
export const loggedEventsAtom = atom([]);
// Store for API logs (max 100)
export const apiLogsAtom = atom([]);
// Helper to add event to store
export const convertToDevToolLoggedEvent = (events, newEvent) => {
    const event = Object.assign(Object.assign({}, newEvent), { id: `${Date.now()}-${Math.random()}`, timestamp: Date.now() });
    // Keep only last 200 events
    const updatedEvents = [event, ...events].slice(0, 200);
    return updatedEvents;
};
// Helper to add API log to store
// 같은 id가 이미 있으면(요청 시 추가된 PENDING row) 새 row를 쌓지 않고 그 자리에서
// 응답/에러 정보를 병합한다 → 요청 1건당 row 1개 (PENDING → 결과로 갱신).
export const convertToDevToolAPILog = (apiLogs, newLog) => {
    var _a, _b;
    if (newLog.id) {
        const index = apiLogs.findIndex(l => l.id === newLog.id);
        if (index >= 0) {
            const merged = [...apiLogs];
            merged[index] = Object.assign(Object.assign(Object.assign({}, merged[index]), newLog), { id: merged[index].id, timestamp: merged[index].timestamp });
            return merged;
        }
    }
    const log = Object.assign(Object.assign({}, newLog), { id: (_a = newLog.id) !== null && _a !== void 0 ? _a : `${Date.now()}-${Math.random()}`, timestamp: (_b = newLog.timestamp) !== null && _b !== void 0 ? _b : Date.now() });
    // Keep only last 100 API logs
    return [log, ...apiLogs].slice(0, 100);
};
// DevTool API tracking helpers
let apiLoggingEnabled = false;
let setAPILogs = null;
export const initializeAPILoggingDevTool = (setter) => {
    apiLoggingEnabled = true;
    setAPILogs = setter;
};
const trackAPI = (apiLog) => {
    if (shouldShowDevTool() && apiLoggingEnabled && setAPILogs) {
        setAPILogs((prev) => convertToDevToolAPILog(prev, apiLog));
    }
};
// Export for external API interceptors to use
export const logAPICall = trackAPI;
